var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.width > 600)?_c('ClientReferalDesk',{attrs:{"RefferalCode":_vm.RefferalCode,"Referral":_vm.Referral},on:{"gencode":_vm.GenerateCode}}):_c('ClientReferalMobile',{attrs:{"RefferalCode":_vm.RefferalCode,"Referral":_vm.Referral},on:{"gencode":_vm.GenerateCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }